/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useEffect, useId, useMemo, useRef } from 'react'
import {
    Checkbox,
    Message,
} from 'semantic-ui-react'

import { useTranslation } from 'react-i18next'
import useDuplicatedCallback from '../helpers/useDeduplicatedCallback'
import { useScanningContext } from './scanning.provider'

export const useScanning = (callback = undefined,condition=true) => {
    const context = useScanningContext()
    const callbackId = useId()

    const isDeviceCompatible = useMemo(() => {
        const scanningCapabilities = context.scanningCapabilities;
        return scanningCapabilities && scanningCapabilities !== 'none'
    }, [context.scanningCapabilities])

    const isAvailable = useMemo(() => {
        return isDeviceCompatible
    }, [isDeviceCompatible])


    // Prevent multiple callbacks in 300ms window.
    const throttledCallback = useDuplicatedCallback((barcode) => {
        callback?.(barcode)
    }, [callback], 300)

    useEffect(() => {
        if (isAvailable && condition) {
            // Register this component as using scanning
            context.registerCallback(callbackId)
            return () => {
                context.unregisterCallback(callbackId);
            }
        }
    }, [isAvailable, callbackId, context.registerCallback, context.unregisterCallback,condition])


    useEffect(() => {
        if (isAvailable && callback) {
            window.addEventListener('barcode', throttledCallback, false)
            return () => {
                window.removeEventListener('barcode', throttledCallback);
            }
        }
    }, [throttledCallback, isAvailable,callback])


    return { 
        isAvailable,
        scanningCapabilities: context.scanningCapabilities,
        toggleCameraScanning: context.toggleCameraScanning,
        displayScanButton: context.displayScanButton,
    }
}


export const ScanningInformationLabel = () => {

    const { isAvailable, scanningCapabilities, toggleCameraScanning,displayScanButton } = useScanning()
    const [t] = useTranslation();

    if(!isAvailable){
        return null;
    }



    return <>
        {scanningCapabilities !== 'camera' && <Message
            css={css`
              &.ui.message:not(:last-child) {
                  margin-bottom: 1.5rem;
              }
          `}
            icon="info"
            size="mini"
            info
            content={t('order.pickup.scan_available_label')}>
        </Message>}
        {scanningCapabilities === 'camera' && <Message
            css={css`
              &.ui.message:not(:last-child) {
                  margin-bottom: 1.5rem;
              }
          `}
            icon="info"
            size="mini"
            info>
            <Message.Content>
                <Checkbox
                      toggle
                      label={t(`order.pickup.${displayScanButton? 'disable' : 'enable'}_camera_scan`)}
                      checked={displayScanButton}
                      onChange={(evt, {checked}) => toggleCameraScanning(checked)}
                    />
                    </Message.Content>
        </Message>}
    </>

}
